import { AbstractControl } from '@angular/forms';

export function CompanyIdValidator(control: AbstractControl) {
    const companyId: RegExp = /[`~!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]/;
    if (control.value && companyId.test(control.value)) {
        return { invalidCompanyId: true };
    }
    return null;
}